import { withDevtools } from '@ngrx-toolkit/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { withIQBoostConversation } from './iqboost-conversation.feature';

export type IQBoostSingleHouseholdState = {
  /** Key of the entry the conversations are about; null until the dialog is first opened. */
  entryKey: string | null;
};

// Outlives the dialog: reopening on the same entry shows the same chat, another entry starts over.
export const IQBoostSingleHouseholdStore = signalStore(
  withDevtools('iqboost-single-household'),
  withIQBoostConversation(),
  withState<IQBoostSingleHouseholdState>({ entryKey: null }),
  withMethods((store) => ({
    /**
     * Makes the store the entry's. The open chat and the list of another entry are dropped: they are
     * about someone else, and its sidebar lists only the entry's own conversations.
     */
    useEntry(entryKey: string): void {
      if (store.entryKey() !== entryKey) {
        patchState(store, () => ({ entryKey, threadId: null, chatHistory: [], conversations: [] }));
      }
    },
  })),
);

export type IQBoostSingleHouseholdStore = InstanceType<typeof IQBoostSingleHouseholdStore>;
